import { render, staticRenderFns } from "./ReceiveNotification.vue?vue&type=template&id=51944a3b&"
import script from "./ReceiveNotification.vue?vue&type=script&lang=js&"
export * from "./ReceiveNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports